import { Component, Optional, Inject, Injector, OnInit, AfterViewInit, OnDestroy, forwardRef } from '@angular/core';
import {
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    NG_ASYNC_VALIDATORS,
    UntypedFormControl,
} from '@angular/forms';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-email',
    templateUrl: './input-email.component.html',
    styleUrls: [
        '../input.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputEmailComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => InputEmailComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class InputEmailComponent extends InputBase<string> implements OnInit, AfterViewInit, OnDestroy
{
    // RFC 2822 compliant regex
    // * https://regexr.com/4lntt
    // tslint:disable-next-line: max-line-length
    private static emailRegexp = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
    private static identifier: number = 0;

    constructor(
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        injector: Injector
    )
    {
        super(injector);

        this.fieldId = `input-email-${InputEmailComponent.identifier++}-id`;
    }

    ngOnInit (): void
    {
    }

    ngAfterViewInit (): void
    {
    }

    ngOnDestroy ()
    {
    }

    // * https://netbasal.com/adding-integrated-validation-to-custom-form-controls-in-angular-dc55e49639ae
    validate ({ value }: UntypedFormControl)
    {
        if (value)
        {
            return value.match(InputEmailComponent.emailRegexp) ? null : { 'emailAddress': true };
        }
    }
}
